import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";
import Center from "../../components/Center";
import { theme } from "../../theme/theme";

const EUPage = () => {
  return (
    <div>
      <Helmet>
        <title>Viidan Tila - EU-tuki</title>
        <meta
          name="description"
          content="Tämä kohde on saanut EU:n maaseuturahoitusta."
        />
      </Helmet>

      <Center>
        <img
          src={require("../../assets/images/eu-support.png")}
          alt="EU Support"
          style={{
            maxWidth: "100%",
            height: "auto",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
        <div
          style={{
            paddingBottom: theme.spacing(12),
            marginTop: "-50px",
          }}
        >
          <h1
            style={{
              fontWeight: "bold",
              color: "#195A95",
              fontSize: "58px",
              lineHeight: "1",
              fontFamily: "Tahoma, sans-serif",
            }}
          >
            Tämä kohde <br /> on saanut EU:n <br /> maaseuturahoitusta
          </h1>
          <p>
            Tilallamme rakennetaan polttopuiden tuotantotiloja, jotta voimme
            taata jatkossakin asiakkaillemme toimitusvarmuuden ja laadukkaan
            polttopuun. Pystymme näin myös kasvattamaan myyntiämme.
          </p>
          <p>
            Olemme saaneet Eu:n maaseuturahoitusta hanketta varten. Rahoituksen
            osuus on 20% toteutuneista kustannuksista.
          </p>
          <p>Kustannusten arviosta 20% vastaa 25443,00 euroa.</p>
        </div>
      </Center>
      <Footer />
    </div>
  );
};

export default EUPage;
